// Generated by https://quicktype.io

import { GuestVenue } from "./focusDataModels/GuestVenue";
import { GuestVenueVisit } from "./focusDataModels/GuestVenueVisit";

export class GuestSearch {
	count: number;
	guestVenue: GuestVenue[];

	public constructor(init?: Partial<GuestSearch>) {
		Object.assign(this, init);
	}
}

export class GuestWeeklyMetric {
	totalNewGuests: number = 0;
	totalGuests: number = 0;
	totalNewGuestRevenue: number = 0;
	totalGuestRevenue: number = 0;
	days: GuestWeeklyMetricDays[];

	public constructor(init?: Partial<GuestWeeklyMetric>) {
		Object.assign(this, init);
	}
}

export class GuestWeeklyMetricDays {
	newGuests: GuestVenueVisit[];
	repeatGuests: GuestVenueVisit[];
	totalGuests: number;
	totalGuestRevenue: number;
	totalNewGuests: number;
	totalNewRevenue: number;
	visitDate: Date;
	checkDate: string;

	public constructor(init?: Partial<GuestWeeklyMetricDays>) {
		Object.assign(this, init);
	}
}
